<script setup lang="ts">
/**
 * Summary rows of quiz results — label left (secondary), value right (primary),
 * 14 above and below, a hairline under each (Style 15 Result, Measurements 10 / 15).
 */
export interface FairQuizSummaryRow {
  key: string
  label: string
  value: string
}

defineProps<{
  rows: FairQuizSummaryRow[]
  /** Shown for an empty value. */
  empty?: string
}>()
</script>

<template>
  <dl class="fair-quiz-summary">
    <div
      v-for="row in rows"
      :key="row.key"
      class="fair-quiz-summary__row"
    >
      <dt class="fair-quiz-summary__label">
        {{ row.label }}
      </dt>
      <dd class="fair-quiz-summary__value">
        {{ row.value || empty || '—' }}
      </dd>
    </div>
  </dl>
</template>
